<script>
import Cascader from 'element-ui/lib/cascader';

export default Cascader;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/cascader.css';
.el-cascader-node {
  &__label {
    @include rtl() {
      text-align: right;
      // padding: 0 20px 0 30px;
      padding: 0 15px 0 25px;
    }
  }

  #{&} &__prefix {
    @include rtl() {
      left: auto;
      right: 10px;
    }
  }

  &__postfix {
    @include rtl() {
      left: 15px;
      right: auto;
      transform: rotate(180deg);
    }
  }
}
</style>
